import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ManureSpaceApiService } from './services/manure-space-api.service';
import { ManureSpaceEffects } from './store/manure-space.effects';
import { manureSpaceReducer } from './store/manure-space.reducer';

@NgModule({
  providers: [
    provideState('manureSpace', manureSpaceReducer),
    provideEffects(ManureSpaceEffects),
    ManureSpaceApiService,
  ],
})
export class ManureSpaceModule {}
